import React from 'react'
import { splitAndGetHead, splitAndGetLast } from 'root/src/shared/util/ramdaPlus'
import pipe from 'ramda/src/pipe'
import prop from 'ramda/src/prop'
import __ from 'ramda/src/__'
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize'
import mediaMimeTypes from 'root/src/shared/constants/mediaMimeTypes'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import { buildAssetUrl, assetSize } from 'root/src/client/v2/common/helpers/assetUrl'

const responsiveBreakpoint = 500

const pickRenderWidth = ({ thumbnail, isMobile }) => {
	if (thumbnail) return assetSize('thumbnail')
	if (isMobile) return assetSize('mobile')
	return assetSize('desktop')
}

export default ({ imageObj, className, alt, children, imageWidth, controls, thumbnail }) => {
	const [width] = useWindowSize()
	const isMobile = width < responsiveBreakpoint
	const { desktop, mobile, url } = imageObj
	// Prefer the raw `url` (new format); fall back to legacy desktop/mobile.
	// Either way we route through buildAssetUrl — it recognises any /files/<key>
	// URL and rewrites it to the on-demand /img/<key> path. Non-image extensions
	// (mp4, svg) and non-matching URLs pass through unchanged.
	const legacyAsset = isMobile ? mobile : desktop
	const rawAsset = url || legacyAsset
	const renderedAsset = rawAsset
		? buildAssetUrl(
			rawAsset,
			{
				w: pickRenderWidth({ thumbnail, isMobile }),
				fmt: 'webp',
				q: 70,
			},
		) || addHttpsProtocol(rawAsset)
		: undefined
	const assetType = rawAsset ? pipe(
		splitAndGetLast('.'),
		prop(__, mediaMimeTypes),
		splitAndGetHead('/'),
	)(rawAsset) : undefined

	return assetType === 'image'
		? (children ? (
			<div
				style={{ backgroundImage: `url(${renderedAsset})` }}
				className={className}
			>
				{children}
			</div>
		)
			: (
				<LazyLoadImage
					src={renderedAsset}
					className={className}
					alt={alt}
				/>
			))
		: assetType === 'video'
			? (
				<video
					className={className}
					style={{ width: imageWidth }}
					muted
					playsInline
					src={renderedAsset}
					controls={controls}
					{...(thumbnail
						? ({
							preload: 'metadata',
						})
						: ({
							autoPlay: true,
							loop: true,
						}))
					}
				/>
			)
			: null
}
